<template>
  <div>
    <Header ref="headerChild"></Header>
    <div class="container">
      <div class="ui relaxed divided list">

        <div class="item" v-for="(list,key) in items" v-if="list !== undefined && list.length > 0">
          <Container class="content" group-name="url" orientation="horizontal" :get-child-payload="getChildPayload(key)"
          @drop="onDrop(key, $event)"
          @drag-start="onDragStart"
          @drag-end="onDragEnd" >
            <Draggable v-for="(val, index) in list" :key="index">
            <a v-bind:data-url="val.url" v-bind:data-name="val.name" v-bind:data-key="key" v-bind:data-index="index"
              v-bind:class="{itemhover:hover, newitem:val.url == '', isedit:isEdit}" @click="onClick($event)">
                <img :src="val.url+'/favicon.ico'" onLoad="this.style.backgroundImage='none'"> {{ val.name }}
              </a>
            </Draggable>
          </Container>
        </div>

      </div>
    </div>
    <Footer></Footer>

    <!-- semantic-ui modal -->
    <div class="ui modal mini">
      <div class="ui header">{{modal.title}}</div>
      <div class="content">
        <form class="ui form">
          <div class="field">
            <input type="text" v-on:keyup.enter="onSubmit" v-model="modal.name" placeholder="name" value="">
          </div>
          <div class="field">
            <input type="text" v-on:keyup.enter="onSubmit" v-model="modal.url" placeholder="example.com" value="">
          </div>
        </form>
      </div>
      <div class="actions">
        <div class="ui grid">
          <div class="nine wide column">
            <div class="ui mini red left floated approve button" v-if="isFix" v-on:click="onDelete(modal.key, modal.index)">Delete</div>
          </div>
          <div class="seven wide column">
            <div class="ui mini basic approve button">Cancel</div>
            <div class="ui mini blue right icon button deny" v-on:click="onSubmit">Save</div>
          </div>
        </div>
      </div>
    </div>
    <!-- semantic-ui modal -->

  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import { Container, Draggable, smoothDnD } from 'vue-smooth-dnd'
import axios from 'axios'


export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult
  if (removedIndex === null && addedIndex === null) return arr

  //新增一行时
  if(arr === undefined)
    arr = []

  const result = [...arr]
  let itemToAdd = payload

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0]
  }
  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd)
  }

  return result
}

export default {
    name: 'Home',
    data () {
      return {
        hover:true,
        newRow:false,
        isEdit:false,
        isFix:false,
        items:[],
        jsondata:'',
        saveing:{},
        modal:{
          title: 'Add',
          id: '',
          name: '',
          url: '',
          key: '',
          index: ''
        }
      }
    },
    components: {
      Header,
      Footer,
      Container,
      Draggable
    },
    methods: {
      onDragStart(dragResult){
        const { isSource, payload, willAcceptDrop } = dragResult

        //增加一行
        let n = this.items.length
        if(this.items[n - 1] === undefined)
          n = n - 1
        if(!this.newRow){
          this.$set(this.items,n,[
            {
              name: "+",
              url: ""
            }
          ])
        }
        this.newRow = true
        this.hover = false
      },
      onDragEnd(dragResult){
        const { isSource, payload, willAcceptDrop } = dragResult
        this.hover = true
        this.newRow = false

        try{
          let last = this.items[this.items.length - 1]
          let lastUrl = last[0].url
          if(lastUrl == ''){
            this.items.pop()
          }
        }catch(e){}
      },
      onDrop(key, dropResult){
        clearTimeout(this.saveing)
        let arr = applyDrag(this.items[key], dropResult)
        if(arr)
          this.items[key] = arr

        let that = this
        this.saveing = setTimeout(function(){
          that.save()
        }, 500)
      },
      onClick(e){
        if(this.isEdit){
          this.show(e.target.dataset)
          return
        }
        window.open(e.target.dataset.url, '_blank');
      },
      getChildPayload(key){
        return index => {
          return this.items[key][index]
        }
      },
      save(){
        let that = this
        var data = new FormData()
        var json = JSON.stringify(this.items)
        json = JSON.parse(json)
        json = json.filter(function(v){
          return v.length != 0
        })
        data.append('json', JSON.stringify(json))
        axios.post('/item/save', data).then(function(res){
          console.log(res)
        })
        .catch(function(err){
          console.log(err)
        })
      },
      edit(){
        this.isEdit = this.isEdit ? false : true
      },
      setLogin(n,t,l,a){
        if(!l){
          this.$refs.headerChild.ssourl = n
          return false
        }

        this.$refs.headerChild.username = n
        this.$refs.headerChild.ssourl = a
        this.$refs.headerChild.target = "_blank"
        this.$refs.headerChild.login = true
        if(t) sessionStorage.setItem('token',t)
      },
      login: function(){
        //get token
        let token = this.$route.query.token //删除浏览器url里的token参数
        if(token){
          let newQuery = JSON.parse(JSON.stringify(this.$route.query))
          delete newQuery.token
          this.$router.replace( { query: newQuery } )
        }else{
          token = sessionStorage.getItem('token') //从sessionStorage
        }

        //ajax
        let that = this
        var data = new FormData()
        if(token) data.append('token', token)
        axios.post('/user/ssologin', data).then(function(res){
          let arr = res.data
          if(arr.status.code == 10200)
            that.setLogin(arr.data.username, token, true, arr.data.account)
          else
            that.setLogin(arr.data.ssourl)

          that.getData()
        })
        .catch(function(err){
            console.log(err)
        })
      },
      getData(){
        var that = this
        axios.get('/item/list')
        .then(function(res){
          that.items = res.data.data
        }, function(error){
          console.log(error)
        })
      },
      // semantic-ui modal functions =============================
      show: function(data){
        if(data){
          this.modal.title = 'Edit'
          this.modal.name = data.name
          this.modal.url = data.url
          this.modal.key = data.key
          this.modal.index = data.index
          this.isFix = true

          let input = $('.ui.form input')
          input.eq(0).val(data.name)
          input.eq(1).val(data.url)
        }else{
          this.isFix = false
          this.modal = {
            title: 'Add'
          }
        }

        $('.ui.modal').modal({
            autofocus: true,
            detachable:false,
            keyboardShortcuts: true,
            observeChanges:true,
            allowMultiple: false,
            onApprove: function(){
              console.log('Cancel')
            },
            onDeny: function(){
              return false
            },
        }).modal('show');
      },
      onSubmit: function(){
        let m = this.modal
        if(!m.name || !m.url)
          return false

        let url = m.url.toLowerCase();
        url.startsWith("http://") || url.startsWith("https://") || (url = "http://" + url), url
        url = url.substring(url.length - 1) == '/' ? url.substring(0, url.length - 1) : url

        if(m.key){
          this.items[m.key][m.index].name = m.name
          this.items[m.key][m.index].url  = url
        } else{
          this.items.push([{name: m.name, url: url}])
        }

        this.save()
        $('.ui.dimmer').click()
      },
      onDelete: function(k, i){
        this.$delete(this.items[k], i)
        this.save()
      }
    },
    created: async function(){
      this.login()
    }
}
</script>

<style scoped>
  .ui.divided.list>.item{
    border-color: rgba(34,36,38,.65);
  }
  .list .smooth-dnd-draggable-wrapper{
    float:left;
  }
  .list a{
    text-decoration: none;
    padding: 10px;
    margin: 0 2px;
    display: block;
    border-radius: 25px;
    border-style: dashed;
    border-width: 1px;
    border-color: #323639;
  }
  .list .smooth-dnd-ghost a,
  .list a.newitem,
  .itemhover:hover{
    background:#a73c3c;
    color:#fff;
    border-style: solid;
  }
  .list a.newitem{
    border-color: #202124;
    background: none;
    width: 100px;
    text-align: center;
    color: #202124;
    font-size: 24px;
  }
  .list a.isedit{
    border-color: #202124;
    background: none;
    width: auto;
  }
  .list a.newitem img{
    width: 0px;
    padding: 0;
    margin: 0;
  }
  .list a img{
    height: 14px;
    width: 14px;
    -webkit-border-radius: 14px;
    -moz-border-radius: 14px;
    border-radius: 14px;
    vertical-align: middle;
    margin-right: 4px;
    background-image: url("/static/images/earth.png");
    background-size: 14px 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue